import { render, staticRenderFns } from "./AdminCountryFaq.vue?vue&type=template&id=0c384bcd&"
import script from "./AdminCountryFaq.vue?vue&type=script&lang=js&"
export * from "./AdminCountryFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports